export function userInfoPayload(parsed, userAgent) {
  const agent = typeof userAgent === 'string' ? userAgent.trim() : ''
  return JSON.stringify({
    ...(parsed && typeof parsed === 'object' ? parsed : {}),
    ...(agent ? { userAgent: agent } : {}),
  })
}
